import React from "react";

const LogoDark = () => {
    return (
        <svg
            className="h-12 sm:h-14 md:h-16 duration-300"
            viewBox="0 0 163 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M128.086 8.32798V20.808C128.086 24.744 126.79 26.376 123.622 26.376C120.598 26.376 119.254 24.648 119.254 20.712V8.32798H111.862V23.4C111.862 29.304 115.222 32.952 120.694 32.952C123.574 32.952 126.55 31.608 128.038 29.64L128.518 32.328H135.478V8.32798H128.086Z"
                fill="#212121"
            />
            <path
                d="M136.225 43.848H143.617V29.928C145.009 31.752 148.081 33 151.393 33C158.545 33 162.673 27.528 162.673 19.944C162.673 12.216 158.017 7.55998 151.345 7.55998C147.937 7.55998 144.913 9.04798 143.569 11.256L143.185 8.32798H136.225V43.848ZM143.665 20.328C143.665 16.728 146.065 14.328 149.521 14.328C153.025 14.328 155.233 16.776 155.233 20.328C155.233 23.88 153.025 26.328 149.521 26.328C146.065 26.328 143.665 23.928 143.665 20.328Z"
                fill="#212121"
            />
            <path d="M9.856 48.328V0.0719757H0V48.328H9.856Z" fill="url(#paint0_linear_7_249)" />
            <path
                d="M11.042 32.264C11.042 42.376 18.466 49.096 28.706 49.096C38.882 49.096 46.306 42.376 46.306 32.264C46.306 22.152 38.882 15.368 28.706 15.368C18.466 15.368 11.042 22.152 11.042 32.264ZM20.962 32.2C20.962 27.4 24.098 24.2 28.706 24.2C33.25 24.2 36.386 27.4 36.386 32.2C36.386 37.064 33.25 40.264 28.706 40.264C24.098 40.264 20.962 37.064 20.962 32.2Z"
                fill="url(#paint1_linear_7_249)"
            />
            <path
                d="M45.812 32.264C45.812 42.376 53.236 49.096 63.476 49.096C73.652 49.096 81.076 42.376 81.076 32.264C81.076 22.152 73.652 15.368 63.476 15.368C53.236 15.368 45.812 22.152 45.812 32.264ZM55.732 32.2C55.732 27.4 58.868 24.2 63.476 24.2C68.02 24.2 71.156 27.4 71.156 32.2C71.156 37.064 68.02 40.264 63.476 40.264C58.868 40.264 55.732 37.064 55.732 32.2Z"
                fill="url(#paint2_linear_7_249)"
            />
            <path
                d="M92.166 48.328V40.328L95.942 36.36L103.11 48.328H114.502L102.854 29L114.886 16.328H102.534L92.166 27.848V0.0719757H82.31V48.328H92.166Z"
                fill="url(#paint3_linear_7_249)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_7_249"
                    x1="57.443"
                    y1="24.9554"
                    x2="57.443"
                    y2="49.096"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FDA4AF" />
                    <stop offset="1" stopColor="#C084FC" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_7_249"
                    x1="57.443"
                    y1="24.9554"
                    x2="57.443"
                    y2="49.096"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FDA4AF" />
                    <stop offset="1" stopColor="#C084FC" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_7_249"
                    x1="57.443"
                    y1="24.9554"
                    x2="57.443"
                    y2="49.096"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FDA4AF" />
                    <stop offset="1" stopColor="#C084FC" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_7_249"
                    x1="57.443"
                    y1="24.9554"
                    x2="57.443"
                    y2="49.096"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FDA4AF" />
                    <stop offset="1" stopColor="#C084FC" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default LogoDark;
